<template>
  <div class="makerTable" :style="{height:isLarge?'calc(100% - 0.4rem)':''}" :shared="shared" ref="makerTable">
    <div class="makerTableContent" :style="{'padding-left':isLeftDrawVisible?'2.6rem':'','padding-right':isRightDrawVisible?'2.6rem':''}">
      <div class="header">
        <div class="left">
          <span class="name">{{layerData.name}}</span>
          <span class="text">（已选择 <span style="color: white">{{selectedData.length}}</span> 条，共 <span style="color: white">{{total}}</span> 条记录）</span>
        </div>
        <div class="right">
          <!-- <el-tooltip content="导出Excel" placement="top" effect="light" :open-delay="1000" :enterable="false">
            <Icon name="icon-filter" @click="exportToExcel" v-show="!isTemplate && !shared"></Icon>
          </el-tooltip> -->
          <!-- <el-tooltip content="导入" placement="top" effect="light" :open-delay="1000" :enterable="false">
            <Icon name="icon-filter" @click="importJson" v-show="!isTemplate && !shared"></Icon>
          </el-tooltip> -->
          <el-tooltip content="筛选" placement="top" effect="light" :open-delay="1000" :enterable="false">
            <Icon name="icon-filter" @click="filterData" v-show="!isTemplate && !shared"></Icon>
          </el-tooltip>
          <el-tooltip content="导出" placement="top" effect="light" :open-delay="1000" :enterable="false">
            <Icon name="icon-share1" @click="exportData" :disabled="permissionLevel <= PermissionLevel.LOOKER" ></Icon>
          </el-tooltip>
          <el-tooltip content="删除" placement="top" effect="light" :open-delay="1000" :enterable="false">
            <Icon name="icon-ashbin" @click="deleteMore" :disabled="permissionLevel <= PermissionLevel.LOOKER"></Icon>
          </el-tooltip>
          <div class="line"></div>
          <el-tooltip content="放大" placement="top" effect="light" @click.native="setLarge(true)" v-if="!isLarge" :open-delay="1000" :enterable="false">
            <Icon name="icon-fullscreen-expand"></Icon>
          </el-tooltip>
          <el-tooltip content="缩小" placement="top" effect="light" @click.native="setLarge(false)" v-else :open-delay="1000" :enterable="false">
            <Icon name="icon-fullscreen-shrink"></Icon>
          </el-tooltip>
          <el-tooltip content="关闭" placement="top" effect="light" @click.native="close" :open-delay="1000" :enterable="false">
            <Icon name="icon-close-bold"></Icon>
          </el-tooltip>
        </div>
      </div>
      <div class="tableBox" @mousewheel="handleScroll">
      <el-table
        v-if="keep"
        v-loading="loading"
        stripe
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
          ref="multipleTable"
          id="multipleTable"
          :data="tableData"
          height="100%"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          v-el-table-infinite-scroll="loadMore"
          @cell-click="clickItem">
        <el-table-column
          type="selection"
          class="selection"
          :width="55*zoomFactor">
        </el-table-column>
        <el-table-column label="序号" :width="60*zoomFactor">
          <template slot-scope="scope">
            <span class="num">{{scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="标注名称" prop="name" :width="columns && columns.length>9?203*zoomFactor:'auto'" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-for="(item ,index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="columns && columns.length>9?203*zoomFactor:'auto'"
          :formatter="item.formatter"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" :fixed="columns && columns.length>9?'right':undefined" :width="80*zoomFactor" v-if="!shared">
          <template slot-scope="scope">
            <div class="action-btn">
              <el-tooltip content="编辑" placement="top" effect="light" :open-delay="1000" :enterable="false">
                <Icon name="icon-edit" @click.stop="openEdit(scope.row)" :disabled="permissionLevel <= PermissionLevel.LOOKER"></Icon>
              </el-tooltip>
              <el-tooltip content="删除" placement="top" effect="light" :open-delay="1000" :enterable="false">
                <Icon name="icon-ashbin" @click.stop="deleteOne(scope.row)" :disabled="permissionLevel <= PermissionLevel.LOOKER"></Icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <Empty></Empty>
        </template>
      </el-table>
      </div>
      <ExportMarkerTable ref="ExportMarkerTable" :columns="columns" :filterParams="filterParams" :layerId="layerData.id"></ExportMarkerTable>
      <FilterMarkerTable ref="FilterMarkerTable" :columns="columns" :filterParams="filterParams" @updateTable="updateTable"></FilterMarkerTable>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import page from '@/mixins/page'
import { getMarkerList, getLayer, delMarker, addMarker } from '@/api/marker'
import ExportMarkerTable from './ExportMarkerTable'
import FilterMarkerTable from './FilterMarkerTable'
import { PermissionLevel } from '@/configs/constants'
import { jsonToExcel } from '@/utils/util'
import axios from 'axios'

export default {
  name: 'MakerTable',
  props: {
    layerData: {
      type: Object,
      default: null
    }
  },
  mixins: [page],
  components: { ExportMarkerTable, FilterMarkerTable },
  inject: ['shared', 'operatLayout'],
  data () {
    return {
      isLarge: false,
      columns: [],
      tableData: [],
      isShow: false,
      params: {
        layerId: null,
        pageNumber: 1,
        pageSize: 20
      },
      // 过滤参数
      filterParams: [],
      isNext: false, // 判断是否有下一页
      customObj: {},
      dialogVisible: false,
      total: 0,
      loading: false,
      selectedRowId: undefined,
      // 缓存数据
      cacheDatas: [],
      keep: true,
      PermissionLevel
    }
  },
  computed: {
    // _layerData () {
    //   return this.layerData
    // },
    ...mapGetters(['isLeftDrawVisible', 'isRightDrawVisible', 'isTemplate', 'spaceSearchJeojson', 'permissionLevel'])
  },
  mounted () {
    if (this.layerData.dataSourceType === 'API') {
      return
    }
    this.filterParams = []
    this.updateTable(this.filterParams)
    this.getLayer()
  },
  watch: {
    layerData (newValue, oldValue) {
      if (newValue && newValue.id !== oldValue.id) {
        this.filterParams = []
        this.updateTable(this.filterParams)
      }
      this.getLayer()
      // this.getMarkerList()
    },
    isRightDrawVisible (v) {
      this.$nextTick(() => {
        this.resize()
      })
    },
    isLeftDrawVisible (v) {
      this.$nextTick(() => {
        this.resize()
      })
    }
  },
  methods: {
    handleScroll () {
      const tooltips = document.getElementsByClassName('el-tooltip__popper')
      if (tooltips.length > 0) {
        tooltips[tooltips.length - 1].style.display = 'none'
      }
    },
    // 获取图层详情,拼接表头
    getLayer () {
      if (this.layerData.id) {
        const params = {
          id: this.layerData.id
        }
        getLayer(params).then((res) => {
          if (res.code === 200) {
            this.columns = []
            if (res.data.properties && res.data.properties.length) {
              res.data.properties.forEach((item) => {
                // 隐藏字段
                if (!item.display) {
                  return
                }
                this.customObj[item.originPropertyId] = item.id.toString()
                this.columns.push({
                  // prop: (item.originPropertyId && item.originPropertyId.toString()) || item.id.toString(),
                  prop: item.id.toString(),
                  label: item.name,
                  type: item.type,
                  options: item.options || []
                })
              })
            }
            // 点标注显示经纬高
            if (res.data.type === 'POINT') {
              this.columns.push({
                prop: 'marker_lon',
                label: '经度_WGS84',
                type: '',
                options: []
              })
              this.columns.push({
                prop: 'marker_lat',
                label: '纬度_WGS84',
                type: '',
                options: []
              })
              this.columns.push({
                prop: 'marker_height',
                label: '高度_WGS84',
                type: '',
                options: []
              })
            }
            this.getMarkerList()
          }
        })
      }
    },
    // 导出excel
    async exportToExcel () {
      const { data } = await getMarkerList({
        layerId: this.layerData.id,
        pageNumber: 1,
        pageSize: 999999
      })
      const jsonData = data.records.map(item => {
        return {
          name: item.name,
          coordinate: JSON.stringify(item.geoJson.geometry.coordinates[0])
        }
      })
      jsonToExcel(jsonData, this.layerData.name)
    },
    async importJson () {
      const layerId = 2480
      const propertyId = 8350
      const { data } = await axios.get('/test.json')
      for (let i = 0; i < data.length; i++) {
        const item = data[i]
        const coordinates = JSON.parse(item.coordinate)
        const geoData = {
          type: 'Feature',
          properties: {
            draw_mode_: '3',
            name: item.name,
            height_: new Array(coordinates.length).fill(0)
          },
          geometry: {
            type: 'Polygon',
            coordinates: [coordinates]
          }
        }
        geoData.properties[propertyId] = item.bizGuid
        await addMarker({
          achievements: [],
          docs: [],
          geoJson: geoData,
          layerId: layerId,
          mark: { values: [{ propertyId: propertyId, value: item.bizGuid }] },
          name: item.name
        })
      }
      console.log('import end')
    },
    // 获取表格数据
    getMarkerList () {
      if (this.layerData && this.layerData.id) {
        this.params.layerId = this.layerData.id
        this.loading = true
        getMarkerList(this.params).then(async res => {
          if (res.code === 200) {
            this.isNext = res.data.next
            this.tableData = []
            this.total = res.data.total
            // todo 优化循环
            let records = res.data.records
            if (res.data.records.length > this.params.pageSize) {
              this.cacheDatas = res.data.records
              const start = (this.params.pageNumber - 1) * this.params.pageSize
              let end = (this.params.pageNumber) * this.params.pageSize
              if (end > this.cacheDatas.length) {
                end = this.cacheDatas.length
              }
              records = res.data.records.slice(start, end)
            }
            records.forEach((item) => {
              item.geoJson.properties.name = item.name

              // 将作为下拉项的列回显为中文
              Object.keys(item.geoJson.properties).forEach(k => {
                if (!item.customize) {
                  this.$set(item.geoJson.properties, this.customObj[k], item.geoJson.properties[k])
                }
                const arr = []
                this.columns.forEach(c => {
                  if (c.prop === k && c.type === 'SELECT' && item.geoJson.properties[k]) {
                    item.geoJson.properties[k].split(',').forEach(p => {
                      c.options.forEach(o => {
                        if (o.id.toString() === p) {
                          arr.push(o.value)
                        }
                      })
                    })
                    item.geoJson.properties[k] = arr.toString()
                  }
                  // 回显日期
                  if (c.prop === k && c.type === 'DATE' && item.geoJson.properties[k]) {
                    item.geoJson.properties[k] = new Date(item.geoJson.properties[k]).format('yyyy-MM-dd')
                  }
                  // 回显日期时间
                  if (c.prop === k && c.type === 'DATE_TIME' && item.geoJson.properties[k]) {
                    item.geoJson.properties[k] = new Date(item.geoJson.properties[k]).format('yyyy-MM-dd hh:mm:ss')
                  }
                })
              })
              const properties = JSON.parse(JSON.stringify(item.geoJson.properties))
              // 点标注添加经纬高
              if (item.geoJson.geometry.type === 'Point') {
                const lon = item.geoJson.geometry.coordinates[0]
                const lat = item.geoJson.geometry.coordinates[1]
                let height = item.geoJson.geometry.coordinates[2]
                if (item.geoJson.properties.height_) {
                  height = JSON.parse(item.geoJson.properties.height_)[0]
                }
                properties.marker_lon = parseFloat(lon).toFixed(6)
                properties.marker_lat = parseFloat(lat).toFixed(6)
                properties.marker_height = height ? parseFloat(height).toFixed(3) : 0
              }

              this.tableData.push(properties)
            })
            if (this.tableData.length < this.cacheDatas.length) {
              this.isNext = true
            }
            this.keep = false
            await this.$nextTick()
            this.keep = true
            this.loading = false
            // this.$nextTick().then(() => this.$forceUpdate())
          }
        })
      }
    },
    setLarge (isLarge) {
      this.isLarge = isLarge
      setTimeout(() => {
        this.reDrawTable()
      }, 300)
    },
    async reDrawTable () {
      this.keep = false
      await this.$nextTick()
      this.keep = true
    },
    // 增加筛选条件查询
    updateTable (v) {
      this.filterParams = v
      this.params.params = encodeURI(JSON.stringify(this.filterParams))
      this.getMarkerList()
    },
    open () {
      this.isShow = true
      this.params.pageNumber = 1
      this.cacheDatas = []
      this.$nextTick(() => {
        this.resize()
      })
    },
    resize () {
      // if (this.isShow) {
      //   this.$nextTick(() => {
      //     const dom = this.$refs.makerTable
      //     if (this.isRightDrawVisible && this.isLeftDrawVisible) {
      //       dom.style.width = '14rem'
      //       dom.style.left = '2.6rem'
      //     }
      //     if (!this.isRightDrawVisible && this.isLeftDrawVisible) {
      //       dom.style.width = '16.6rem'
      //       dom.style.left = '2.6rem'
      //     }
      //     if (this.isRightDrawVisible && !this.isLeftDrawVisible) {
      //       dom.style.width = '16.6rem'
      //       dom.style.left = '0'
      //     }
      //     if (!this.isRightDrawVisible && !this.isLeftDrawVisible) {
      //       dom.style.width = '100%'
      //       dom.style.left = '0'
      //     }
      //   })
      // }
    },
    // 点击编辑
    openEdit (row) {
      this.$emit('editMarker', { id: row.mark_id_ })
    },
    deleteOne (row) {
      this.$Delete({
        confirm: () => {
          delMarker({ ids: [row.mark_id_] }).then(res => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              if (row.mark_id_ === this.selectedRowId) {
                this.operatLayout.showMarkerDetail(false)
              }
              this.$cesiumPlus.markerManager.removeMarkerById(row.mark_id_)
              this.getMarkerList()
              this.$emit('refresh')
            }
          })
        },
        cancel: () => {
        }
      })
    },
    deleteMore () {
      if (this.selectedData.length === 0) {
        this.$Message('warning', '请先勾选数据！')
      } else {
        const ids = []
        this.selectedData.forEach((item) => {
          ids.push(item.mark_id_)
        })
        this.$Delete({
          confirm: () => {
            delMarker({ ids: ids }).then(res => {
              if (res.code === 200) {
                this.$Message('success', res.msg)
                if (ids.indexOf(this.selectedRowId) >= 0) {
                  this.operatLayout.showMarkerDetail(false)
                }
                for (let i = 0; i < ids.length; i++) {
                  this.$cesiumPlus.markerManager.removeMarkerById(ids[i])
                }
                this.getMarkerList()
                this.selectedData = []
                this.$emit('refresh')
              }
            })
          },
          cancel: () => {
          }
        })
      }
    },
    close () {
      this.filterParams = []
      this.updateTable(this.filterParams)
      this.$emit('closeMarkerTable')
      this.$emit('updateMarkerTable')
      this.isShow = false
    },
    // 刷新表格数据
    refreshTableData () {
      this.$nextTick(() => {
        this.getLayer()
        // this.getMarkerList()
      })
    },
    clickItem (row) {
      this.selectedRowId = row.mark_id_
      this.$emit('detailMarker', row.mark_id_)
    },
    // 滚动底部加载更多
    loadMore () {
      if (this.isNext) {
        this.params.layerId = this.layerData.id
        this.params.pageNumber++
        this.loading = true
        getMarkerList(this.params).then(res => {
          if (res.code === 200) {
            this.isNext = res.data.next
            // this.tableData = []

            let records = res.data.records
            if (res.data.records.length > this.params.pageSize) {
              this.cacheDatas = res.data.records
              const start = (this.params.pageNumber - 1) * this.params.pageSize
              let end = (this.params.pageNumber) * this.params.pageSize
              if (end > this.cacheDatas.length) {
                end = this.cacheDatas.length
              }
              records = res.data.records.slice(start, end)
            }
            records.forEach((item) => {
              item.geoJson.properties.name = item.name

              // 将作为下拉项的列回显为中文
              Object.keys(item.geoJson.properties).forEach(k => {
                if (!item.customize) {
                  this.$set(item.geoJson.properties, this.customObj[k], item.geoJson.properties[k])
                }
                const arr = []
                this.columns.forEach(c => {
                  if (c.prop === k && c.type === 'SELECT' && item.geoJson.properties[k]) {
                    item.geoJson.properties[k].split(',').forEach(p => {
                      c.options.forEach(o => {
                        if (o.id.toString() === p) {
                          arr.push(o.value)
                        }
                      })
                    })
                    item.geoJson.properties[k] = arr.toString()
                  }
                  // 回显日期
                  if (c.prop === k && c.type === 'DATE' && item.geoJson.properties[k]) {
                    item.geoJson.properties[k] = new Date(item.geoJson.properties[k]).format('yyyy-MM-dd')
                  }
                  // 回显日期时间
                  if (c.prop === k && c.type === 'DATE_TIME' && item.geoJson.properties[k]) {
                    item.geoJson.properties[k] = new Date(item.geoJson.properties[k]).format('yyyy-MM-dd hh:mm:ss')
                  }
                  // 点标注添加经纬高
                  if (item.geoJson.geometry.type === 'Point') {
                    const lon = item.geoJson.geometry.coordinates[0]
                    const lat = item.geoJson.geometry.coordinates[1]
                    let height = item.geoJson.geometry.coordinates[2]
                    if (item.geoJson.properties.height_) {
                      height = JSON.parse(item.geoJson.properties.height_)[0]
                    }
                    item.geoJson.properties.marker_lon = parseFloat(lon).toFixed(6)
                    item.geoJson.properties.marker_lat = parseFloat(lat).toFixed(6)
                    item.geoJson.properties.marker_height = height ? parseFloat(height).toFixed(3) : 0
                  }
                })
              })
              this.tableData.push(item.geoJson.properties)
            })
            if (this.tableData.length < this.cacheDatas.length) {
              this.isNext = true
            }
            this.loading = false
          }
        })
      }
    },
    // 导出数据
    exportData () {
      this.$refs.ExportMarkerTable.open(this.layerData.name)
    },
    // 过滤筛选
    filterData () {
      this.$refs.FilterMarkerTable.open()
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.makerTable{
  width: 100%;
  height: 289px;
  background: #272829;
  box-shadow: 2px 0px 6px 0px rgba(12, 35, 91, 0.1);
  // z-index: 100;
  position: absolute;
  bottom: 0;
  // left: 260px;
  padding: 0 12px 12px 12px;
  box-sizing: border-box;
  transition: all 0.3s;
  .makerTableContent{
    box-shadow: 2px 0px 6px 0px rgba(12, 35, 91, 0.1);
    height: 100%;
  }
  // &[shared]{
  //    width: 1660px !important;
  // }
  .header{
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      .name{
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #FFFFFF;
      }
      .text{
        color: rgba(153, 153, 153, 1);
      }
    }
    .right{
      display: flex;
      align-items: center;
      justify-content: space-between;
      // width: 150px;
      .custom-icon{
        margin-right: 10px;
        >svg{
          color: white;
        }
      }
      .line{
        width: 1px;
        height: 14px;
        background: #FFFFFF;
        opacity: 0.1;
        border-radius: 1px;
      }
    }
  }
  .tableBox{
    height: calc(100% - 36px);
    .el-table{
      height: 100%;
      background-color: #272829;
      .el-table__body-wrapper{
        height: calc(100% - 40px) !important;
      }
    }
  }

  .custom-empty {
    margin-bottom: 0px;
  }
}
</style>
